import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import ProductivityDashboard from './components/ProductivityDashboard';
import MobileApp from './components/MobileApp';

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      // Check if viewport is mobile size OR if device is touch-enabled
      const isMobileSize = window.innerWidth <= 768;
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      setIsMobile(isMobileSize || (isTouchDevice && window.innerWidth <= 1024));
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={isMobile ? <MobileApp /> : <ProductivityDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
